module.exports = __webpack_public_path__ + "img/1015423338.05177ea8.png";